import * as React from 'react';
import * as _ from 'lodash'
import * as moment from 'moment'
import { Button, ButtonType } from 'office-ui-fabric-react';
import Progress from '../views/Progress';
import Message from '../views/Message';
import CampaignStart from '../views/CampaignStart';
import CampaignView from '../views/CampaignView';
import { clientLog, apiCreateCampaign, apiGetCampaign, apiSetCampaignSettings, apiUploadSourceData, apiSetCampaignPreview } from '../util'

export interface Props {

}

export interface State {

}

export default class Debugger extends React.Component {

    static log = "";

    static appendLog = (msg: string) => {
        Debugger.log = Debugger.log + msg + "\n";
    }

    dump = () => {
        Office.context.mailbox.item.to.getAsync({}, async (result) => {

            if (result.error) {
                console.error(result.error);
            } else {
                console.log(result);
            }

        });
    }

    set = () => {
        Office.context.mailbox.item.to.addAsync([{
            displayName: `MailMerge365 Campaign`,
            emailAddress: "test@example.com",
        }], (result) => {
            console.log(result);
        });
    }


    render() {
        return <>
            <b>Debug</b><br />
            <textarea style={{ "width": "100%", "minHeight": "100px" }}>{Debugger.log}</textarea>
            <button onClick={this.dump}>Dump props</button>
            <button onClick={this.set}>Set props</button>
        </>
    }
}
